// @TODO: this combines web and native styles which i don't prefer
/**
 * Ryan O'Dowd
 * 2018-04-16
 * © Copyright 2018 Oakwood Software Consulting, Inc. All Rights Reserved.
 */

const getStyles = ({fonts, globalScale, colors}) => {
  const fillStyles = {
    borderRadius: globalScale * 8,
    borderWidth: 0,
    transform: 'initial',
  };

  let completedScoreColors: any = [...Array(30).fill(colors.accent).flatMap((c, i) => i % 2 ? [c + '22', c + '77'] : [c + '77', c + '22'])];
  completedScoreColors.shift();
  completedScoreColors = [...completedScoreColors, colors.accent].map((c, i) => `${c} ${(100 / completedScoreColors.length) * i}%, ${c} ${(100 / completedScoreColors.length) * (i + 1)}%`).join(', ');

  return {
    row: {
      flexDirection: 'row',
    },
    headerWrapper: {
      flex: 1,
      width: '100%',
      flexDirection: 'column',
      justifyContent: 'space-between',
      alignItems: 'flex-start',
      marginRight: globalScale * 8,
    },
    chapterMetadataWrapper: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
    },
    firstRow: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'center',
      alignItems: 'center',
    },
    passageTitle: {
      flex: 1,
      fontSize: globalScale * 16,
      fontFamily: fonts.secondaryBold,
      color: colors.white,
    },
    rightActions: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'center',
      alignItems: 'center',
    },
    passageActionButton: {
      marginTop: globalScale * 0,
      marginRight: globalScale * 4,
      marginBottom: globalScale * 0,
      marginLeft: globalScale * 4,
      borderWidth: globalScale * 1,
      borderColor: colors.accent,
      backgroundColor: colors.primaryDark,
    },
    disabledButton: {
      opacity: 0.3,
      borderColor: colors.gray,
      backgroundColor: colors.lightGray,
    },
    levelFiveButton: {
      borderColor: colors.accent,
      backgroundColor: `${colors.accent}22`,
    },
    fakeWrinkleBadge: {
      position: 'absolute',
      top: -4,
      right: 0,
      borderWidth: globalScale * 1,
      borderColor: colors.white,
      backgroundColor: colors.alert,
      width: globalScale * 20,
      height: globalScale * 20,
      borderRadius: globalScale * 10,
      justifyContent: 'center',
      alignItems: 'center',
    },
    levelText: {
      fontSize: globalScale * 12,
      fontFamily: fonts.secondaryBold,
      color: colors.white,
      textAlign: 'center',
    },
    closedTestIcon: {
      borderColor: colors.lightGray,
      backgroundColor: colors.gray,
    },
    normalizedScoreWrapper: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'flex-start',
      alignItems: 'center',
      width: '100%',
      borderColor: colors.primaryLight,
      borderWidth: 2,
      borderRadius: 8,
    },
    normalizedScoreGradient: {
      display: 'flex',
      width: '100%',
      justifyContent: 'center',
      alignItems: 'flex-start',
      height: globalScale * 10,
      borderRadius: 4,
      backgroundColor: 'transparent',
      borderWidth: 0,
    },
    normalizedScoreFill: (widthPercentage) => {
      const normalizedScoreNormalizedWidth = 100 * (100 / widthPercentage);

      return {
        ...fillStyles,
        background: `linear-gradient(90deg, ${colors.incorrect} 0%, ${colors.accentLight} ${normalizedScoreNormalizedWidth / 2}%, ${colors.accent} ${normalizedScoreNormalizedWidth}%)`,
        width: `${widthPercentage}%`,
      };
    },
    normalizedScoreFillCompleted: {
      ...fillStyles,
      background: `linear-gradient(115deg, ${completedScoreColors})`,
    },
    completedNormalizedScoreWrapper: {
      borderColor: colors.accent,
    },
    zeroNormalizedScoreWrapper: {
      borderWidth: 0,
    },
    emptyScore: {
      width: 10,
      height: 2,
      backgroundColor: colors.primaryDark,
    },
    versesWrapper: {
      // @TODO: height: 200, // @TODO: shouldn't have to hardcode this
      // @TODO: height: '100%',
      // @TODO:
      flex: 1,
      // @TODO: maxHeight: 500, // @TODO: better value
      margin: 0,
      padding: 0,
    },
  };
};

export default getStyles;
